var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMindfulness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14684 13.8402L5.14955 9.84293C4.56194 9.25532 4.23828 8.47402 4.23828 7.64297C4.23828 6.81193 4.5619 6.03062 5.14955 5.44301C5.73721 4.8554 6.51847 4.53174 7.34951 4.53174C8.00257 4.53174 8.62487 4.73159 9.1467 5.10233C9.66849 4.73154 10.2908 4.53174 10.9438 4.53174C11.7749 4.53174 12.5562 4.85536 13.1438 5.44296C14.3569 6.65604 14.3569 8.62986 13.1439 9.84293L9.14684 13.8402ZM7.34951 5.93021C6.89206 5.93021 6.46192 6.10838 6.13845 6.43186C5.81497 6.75533 5.6368 7.18547 5.6368 7.64292C5.6368 8.10042 5.81492 8.53051 6.13845 8.85399L9.14684 11.8624L12.155 8.85404C12.8227 8.18625 12.8227 7.09969 12.155 6.4319C11.8314 6.10838 11.4013 5.93021 10.9438 5.93021C10.4864 5.93021 10.0562 6.10838 9.73277 6.43186L9.14689 7.01811L8.56068 6.43186C8.23711 6.10838 7.80702 5.93021 7.34951 5.93021Z",
    fill: "url(#paint0_linear_6573_1840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0237 23.9337H3.77073V16.654C1.37307 14.9063 -0.0295491 12.1274 0.000472338 9.14571C0.0248998 6.70679 0.988897 4.42292 2.71481 2.71482C4.44039 1.00705 6.73423 0.0664062 9.17329 0.0664062H9.17343C14.2316 0.0664529 18.3466 4.18163 18.3466 9.23979C18.3466 9.54737 18.331 9.85751 18.3001 10.1649L19.7026 12.3306C19.8972 12.6309 20 12.9788 20 13.3367C20 14.3572 19.1697 15.1875 18.1492 15.1875H17.7359V17.538C17.7359 19.022 16.5286 20.2293 15.0446 20.2293H14.0238V23.9337H14.0237ZM5.16925 22.5352H12.6252V18.8308H15.0445C15.7574 18.8308 16.3373 18.2508 16.3373 17.538V13.7889H18.1492C18.3986 13.7889 18.6014 13.586 18.6014 13.3366C18.6014 13.2492 18.5763 13.1642 18.5288 13.0909L16.8503 10.4992L16.8832 10.2447C16.9262 9.91243 16.9481 9.57436 16.9481 9.23979C16.9481 4.95278 13.4604 1.46502 9.17339 1.46492C7.10498 1.46492 5.16062 2.2618 3.69852 3.70884C2.23633 5.15593 1.41959 7.0918 1.39885 9.15974C1.37242 11.7944 2.66572 14.2424 4.85854 15.7082L5.1692 15.9159L5.16925 22.5352Z",
    fill: "url(#paint1_linear_6573_1840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1840",
    x1: 6.67379,
    y1: 5.09043,
    x2: 11.1474,
    y2: 13.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1840",
    x1: 4.96266,
    y1: 1.4989,
    x2: 17.6845,
    y2: 19.9635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindfulness);
export default __webpack_public_path__ + "static/media/mindfulness.04a97e0f231d66a4376b5648888093bd.svg";
export { ForwardRef as ReactComponent };